import { IconList } from '@cinch-nx/data-storyblok'
import { SvgIcon } from '@cinch-labs/design-system'

import styles from './why-app.module.css'

export interface WhyAppInformationProps {
  heading: string
  listOfItems: IconList[]
  ariaLabelForList: string
  disclaimer: string
}

interface ComponentMapType {
  [key: string]: JSX.Element
}

const ComponentMap: ComponentMapType = {
  cash: <SvgIcon name="cash" size={24} />,
  filter: <SvgIcon name="filter" size={24} />,
  'home-delivery': <SvgIcon name="home-delivery" size={24} />,
  'vehicle-front': <SvgIcon name="vehicle-front" size={24} />,
} as const

export const WhyAppInformation = ({
  heading,
  listOfItems,
  ariaLabelForList,
  disclaimer,
}: WhyAppInformationProps) => (
  <section className={styles.whyAppInformationContainer}>
    <h1 className={styles.whyAppInformationSectionHeading}>{heading}</h1>
    <ul
      aria-label={ariaLabelForList}
      className={styles.whyAppInformationSectionList}
    >
      {listOfItems.map((item: IconList) => {
        const iconName = item.icon

        return (
          <li
            key={item.text}
            aria-label={item.text}
            className={styles.whyAppInformationListItem}
          >
            <div
              className={styles.whyAppInformationIconCard}
              data-testid={`${iconName}-icon`}
            >
              {ComponentMap[iconName]}
            </div>
            <div className={styles.whyAppInformationIconCardText}>
              {item.text}
            </div>
          </li>
        )
      })}
    </ul>
    <p className={styles.whyAppInformationDisclaimer}>{disclaimer}</p>
  </section>
)
